export class DocumentStates {
  static MANUAL_PROCESSED = 'MANUAL_PROCESSED'
  static NEEDS_ANNOTATION = 'NEEDS_ANNOTATION'
  static SELF_ANNOTATED = 'SELF_ANNOTATED'
  static IN_PROGRESS = 'IN_PROGRESS'
  static PROCESSED = 'PROCESSED'
  static REJECTED = 'REJECTED'
}
